<template>
  <div class="sac-filter-option">
    <button
      :id="`${item.key}-filter`"
      type="button"
      :class="[
        dark ? 'nav-button-dark' : 'nav-button',
        `container-${item.key}`,
        item.active ? 'active' : '',
        item.options.length === 0 ? 'disabled' : '',
      ]"
      @click="toggleOptions()"
    >
      <span
        :class="[`${maxWidth}`,
                 'flex-row flex-1 just-between align-center',
        ]"
      >
        <span
          :class="[dark && !item.active ? 'sac__font-16 med' : 'sac__font-16 f-white med', `${ellipsis}`]"
        >
          {{ getLabel(item.label, item.activeOption, item.active) }}
        </span>
        <img
          v-if="dark & !item.active"
          alt="Down"
          src="@shared/assets/img/general/chevron-down.png"
          class="img-size-6"
        >
        <img
          v-else
          alt="Up"
          src="@shared/assets/img/general/chevron-white-down.png"
          class="img-size-24"
        >
      </span>
    </button>
    <div
      :class="[
        'options',
        (!loading && show) ? 'show-options' : '', `hide-${item.key}`,
        checkIfOnEdge(),
      ]"
    >
      <div class="flex-center-column">
        <div class="sac__font-14 med">
          {{ item.label }}
        </div>
        <button
          v-if="!item.hideClear"
          type="button"
          class="sac__font-14 f-primary semi-bold"
          @click="clearOptions(item.key)"
        >
          Clear
        </button>
      </div>
      <div
        v-if="item.key !== 'techs' && item.key !== 'branch' && item.key !== 'psms'"
        class="flex-row align-center"
      >
        <button
          v-for="(option, idx) in item.options"
          :key="idx"
          type="button"
          :class="[
            isOptionActive(item.activeOption, option) ? 'active' : '',
            'select-button',
          ]"
          @click="selectOption(option, item.key)"
        >
          <span class="sac__font-14 med">
            {{ option.label }}
          </span>
        </button>
      </div>
      <div v-if="item.key === 'dateCreated'">
        <div v-if="item.activeOption.value === 'custom'" class="option-container">
          <CustomDateRangeFilter />
        </div>
      </div>
      <SACFilterSearchOption
        v-else-if="item.key === 'techs' || item.key === 'psms'"
        :item="item"
        :select="selectOption"
      />
    </div>
  </div>
</template>

<script>
import SACFilterSearchOption from './SACFilterSearchOption.vue';
import CustomDateRangeFilter from '../service/serviceFilter/CustomDateRangeFilter.vue';

export default {
  name: 'SACFilterOption',
  components: {
    SACFilterSearchOption, CustomDateRangeFilter,
  },
  props: {
    item: {
      type: Object,
    },
    dark: Boolean,
    loading: Boolean,
    change: Function,
    clear: Function,
    maxWidth: {
      type: String,
      default: 'auto',
    },
    ellipsis: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    document.querySelector(`:not(.hide-${this.item.key})`).addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(`:not(.hide-${this.item.key})`).removeEventListener('click', this.closeOnClick);
  },
  methods: {
    selectOption(option, key) {
      this.change(option, key);
      this.show = false;
    },
    clearOptions(key) {
      this.clear(key);
      this.show = false;
    },
    toggleOptions() {
      if (!this.loading) {
        this.show = true;
      }
    },
    getLabel(label, activeOption, isActive) {
      let val = label;
      if (isActive && Array.isArray(activeOption)) {
        if (activeOption.length === 1) {
          val = activeOption[0].label;
        } else if (activeOption.length > 1) {
          val = `${activeOption[0].label} (+${activeOption.length})`;
        }
      } else if (isActive && label === 'Urgent') {
        val = 'Urgent';
      } else if (isActive) {
        val = activeOption.label;
      }
      return val;
    },
    isOptionActive(activeOption, option) {
      if (Array.isArray(activeOption)) {
        return activeOption.some((actOpt) => actOpt.value === option.value);
      } if (activeOption && typeof activeOption === 'object') {
        return activeOption.value === option.value;
      }
      return false;
    },
    closeOnClick(e) {
      if (!e.target.closest(`.container-${this.item.key}`) && !e.target.closest(`.hide-${this.item.key}`) && this.show) {
        this.show = false;
      }
    },
    checkIfOnEdge() {
      const filter = document.getElementById(`${this.item.key}-filter`);
      if (filter) {
        const {
          x,
        } = filter.getBoundingClientRect();
        if (window.innerWidth - x < 200) {
          return 'right-popup';
        }
        if (x < 200) {
          return 'left-popup';
        }
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.sac-filter-option {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .nav-button-dark {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 10px;
    height: 44px;
    cursor: pointer;
    padding: 0 15px;
    background-color: $NBLUE5;
    border-radius: 6px;

    &.active {
      background-color: $NBLUE110;
      color: white;
    }

    @media (max-width: 850px) {
      height: 36px;
    }
  }
  .nav-button {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 10px;
    height: 44px;
    cursor: pointer;
    padding: 0 15px;
    background-color: $N95;
    border-radius: 6px;

    &.active {
      background-color: $NBLUE110;
    }

    &:hover {
      background-color: $N90;
    }

    @media (max-width: 850px) {
      height: 36px;
    }
  }

  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .options {
    display: none;
    position: absolute;
    min-width: 400px;
    background-color: $WHITE;
    top: 60px;
    padding: 24px;
    box-shadow: 0 3px 6px rgba(9, 15, 32, 0.07);
    border-radius: 6px;
    white-space: nowrap;
    z-index: 3;
    gap: 20px;

    @media(max-width: 850px) {
      left: -75px;
      width: 250px;
      padding: 16px;

      .f-16 {
        font-size: 0.75em;
      }
    }

    &:hover {
      display: grid;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-bottom-color: $WHITE;
      border-top: 0;
      margin-left: -8px;
      margin-top: -8px;
    }

    &.show-options {
      display: grid;
    }

    &.right-popup {
      left: -235px;

      &:after {
        left: 80%;
      }

      @media (max-width: 850px) {
        left: -155px;
      }
    }
  }

  .select-button {
    &:first-child {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    &:last-child {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
}
</style>
